export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(document).ready(() => {
        function hsEvents() {
            window.HubSpotConversations.on('widgetClosed', () =>{
                $('.form-modal').hide();
            });
            window.HubSpotConversations.on('conversationStarted', () => {
                /* global LogRocket gtag */
                LogRocket.track('conversationStarted');
                gtag('event', 'conversationStarted');
            });
        }

        $('.hamburger').on('click', () => {
            $('#menu-main').toggleClass('mobile-showing');
        });
        var _paq = _paq || [];
        // CTA form submission  
        if ($('.gform_confirmation_message_' + cta_object.form_id).length > 0) {
            $('.form-modal').show();
        }
        // Modal toggles
        $('a[href="#cta"]').on('click', () => {
            window.HubSpotConversations.widget.open();
            $('.form-modal').show();
            return false;
        });
        $('.form-modal, .modal-cancel').on('click', function(e){
            if(e.target == this){
                $('.form-modal').hide();           
            }
        });
        $(document).keyup(function(e) {
            if (e.keyCode == 27) {
                $('.form-modal').hide();
            }
        });
        if (window.HubSpotConversations) {
            hsEvents();
        } else {
            window.hsConversationsOnReady = [hsEvents];
        }
    });
  },
};
